export enum PrioridadEstado {
  Baja,
  Media,
  Alta,
}

export const PrioridadEstadoLabels: { [key in PrioridadEstado]: string } = {
  [PrioridadEstado.Baja]: 'Baja',
  [PrioridadEstado.Media]: 'Media',
  [PrioridadEstado.Alta]: 'Alta',
};

export const getPrioridadEstado = () => {
  return Object.values(PrioridadEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: PrioridadEstadoLabels[id as PrioridadEstado],
    }));
};
export const colorMapping: { [key in PrioridadEstado]: string } = {
  [PrioridadEstado.Baja]: '#70BDFF',
  [PrioridadEstado.Media]: 'orange',
  [PrioridadEstado.Alta]: '#FF0000',
};
